import { Box } from "@mui/material"

const BrandLogo = ({img_url,width='100px',height="100px"})=>{
    return (
        <Box sx={{background:'radial-gradient(circle, rgba(255, 104, 162, 1) , rgba(252, 39, 121, 1) 50%)' ,border:'4px solid #fff',borderRadius:'50%',padding:'5px',boxShadow: '0 4px 14px rgb(6 0 0 / 34%)' , overflow:'auto'}}>
            <img src={img_url} style={{width:width,height:height,objectFit:'contain'}}/>
        </Box>
    )
}
export default BrandLogo